import { useMemo } from "react";import { useScheduleContext } from "../../../hooks/context/useScheduleContext";
import { useDateFilters } from "../../../../../../components/shared/filters/DateFilters/context/useDateFilters";

function CurrentTime({ currentTimeOffset, header, cellIndex, cellWidth, height }: any) {
    const { mode } = useDateFilters();
    const { showTimeline } = useScheduleContext();

    const content = useMemo(() => {
        if (!(mode === "day" && showTimeline && currentTimeOffset !== null)) return null;
        if (!!header) {
            const cellStartPx = cellIndex * cellWidth;
            const cellEndPx = cellStartPx + cellWidth;
            const isVisible = currentTimeOffset >= cellStartPx && currentTimeOffset < cellEndPx;
            if (isVisible) {
                const sphereLeftPosition = currentTimeOffset - cellStartPx;
                return (
                    <div
                        className="tw-absolute tw-bottom-0 tw-w-3 tw-h-3 tw-rounded-full tw-bg-primary tw-z-10"
                        style={{
                            left: `calc(${sphereLeftPosition}px - 5px)`,
                        }}
                    />
                );
            }
            return null;
        } else {
            return (
                <div
                    className="tw-absolute tw-top-0 tw-border-l-2 tw-border-dashed tw-border-primary tw-z-10 tw-pointer-events-none"
                    style={{
                        left: `${currentTimeOffset}px`,
                        height: height || "100%",
                    }}
                />
            );
        }
    }, [header, mode, showTimeline, currentTimeOffset, cellIndex, cellWidth, height]);

    return content;
}

export default CurrentTime;
